import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import user from './user/sagas';

export default function* rootSaga() {
    yield all([
        authSaga(), user]);
}
